import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { Link, useParams } from 'react-router-dom';
import XmpieService from "api/precision/XmpieService";

const CustomizeSetup = ({ product, adors, getAdor, getAdorValue, updateAdorValue }) => {
  const popoverRef = useRef()
  const [curAdorName, setCurAdorName] = useState(null);

  const validations = [];
  const formats = [];
  useEffect(() => {
    //console.log(adors);
  });

  const handleChange = (e) => {
    e.stopPropagation();
    if (e.target.name == "curAdorName") {
      setCurAdorName(e.target.value);
    }
    else {
      updateAdorValue(curAdorName, e.target.name, e.target.value);
    }
  }

  // debugger;
  const adorNameList = useMemo(() => {
    let rv = [];
    for (let key in adors) {
      rv.push(key);
    }
    return rv;
  });

  // Return current ador object
  const curAdor = () => {
    return getAdor(curAdorName);
  };

  const label = () => {
    const lab = getAdorValue(curAdorName, "label");
    return lab && (
      <input value={curAdor.label} name="label" className="form-control" type="text" onChange={handleChange} />
    )
  }

  const uiType = () => {
    const type = getAdorValue(curAdorName, "label");
    return type && (
      <select value={curAdor.ui_type} name="ui_type" className="form-control" onChange={handleChange}>
        <option value=""></option>
        <option value="text">Text Box</option>
        <option value="list">Dropdown List</option>
        <option value="number">Number</option>
        <option value="tel">Phone</option>
        <option value="email">Email</option>
        <option value="url">Url</option>
        <option value="date">Date Time</option>
        <option value="time">Time</option>
        <option value="month">Month</option>
        <option value="week">Week</option>
        <option value="textarea">Text area</option>
        <option value="graphic">Graphic</option>
        <option value="excel">Excel (Import)</option>
      </select>
    )
  }

  const fillSource = () => {
    const uiType = getAdorValue(curAdorName, "ui_type");
    if (uiType == "list") {
      return (
        <select value={curAdor.data_source} name="data_source" className="form-control" onChange={handleChange}>
          <option value=""></option>
          <option value="customlist">Custom List</option>
          <option value="userAddressList">User Address List</option>
          <option value="departmentAddressList">Department Address List</option>
          <option value="imagelist">Image List</option>
        </select>)
    }
    else if (uiType == "text") {
      return (
        <select value={curAdor.data_source} name="data_source" className="form-control" onChange={handleChange}>
          <option value=""></option>
          <option value="userProfile">User Profile</option>
        </select>)
    }
    else if (uiType == "graphic") {
      return (
        <select value={curAdor.data_source} name="data_source" className="form-control" onChange={handleChange}>
          <option value=""></option>
          <option value="imageupload">Image Upload</option>
          <option value="gallery">Gallery</option>
        </select>)
    }
  };

  const fillWith = () => {

    const dSource = getAdorValue(curAdorName, "data_source");
    if (dSource == "customlist" || dSource == 'imagelist') {
      return (
        <div className="mb-2 ms-2">
          Add Action List Items
        </div>);
    }
    else if (dSource == 'userProfile') {
      return (
        <select value={curAdor.fill_with} name="fill_with" className="form-control" onChange={handleChange}>
          <option value=""> </option>
          <optgroup label="User Profile">
            <option value="title">Title</option>
            <option value="full_name">Full Name</option>
            <option value="first_name">First Name</option>
            <option value="last_name">Last Name</option>
            <option value="email">Email</option>
            <option value="phone">Phone</option>
            <option value="cell">Cell</option>
            <option value="fax">Fax</option>
          </optgroup>
        </select>)
    }
    else if (dSource == 'userAddressList' || dSource == 'departmentAddressList') {
      return (
        <select value={curAdor.fill_with} name="fill_with" className="form-control" onChange={handleChange}>
          <optgroup label="Address">
            <option value="title">Title</option>
            <option value="line1">Line 1</option>
            <option value="line2">Line 2</option>
            <option value="city">City</option>
            <option value="state">State Abbriviate</option>
            <option value="province">State/Province</option>
            <option value="zip_code">Zip Code</option>
            <option value="country">Country</option>
            <option value="phone">Phone</option>
            <option value="citystate">City State</option>
            <option value="citystatezip">City, State Zipcode</option>
          </optgroup>
        </select>)
    }
  };

  const selValidations = () => {
    /*
    return (
      <select value="curAdor.validation" name="validation" className="form-control" onChange={handleChange}>
        <option value=""></option>
        <optgroup label="Phone">
          {
            validations.phone.map((item) => (
              <option value={item.value}>{item.name}</option>
            ))
          }
        </optgroup>
        <optgroup label="Number">
          {
            validations.number && validations.number.map((item) => (
              <option value={item.value}>{item.name}</option>
            ))
          }
        </optgroup>
        <optgroup label="Text">
          {
            validations.text.map((item) => (
              <option value={item.value}>{item.name}</option>
            ))
          }
        </optgroup>
        <optgroup label="Date Time">
          {
            validations.datetime.map((item) => (
              <option value={item.value}>{item.name}</option>
            ))
          }
        </optgroup>
      </select>
    );
    */
  }

  const triggers = () => {
    if (!curAdor.listen) {
      return;
    }
    return (
      <div className="card mb-2">
        <div className="card-header"><b>Trigger</b></div>
        <div className="card-body">
          <div className="row small mb-2">
            <div className="col">
              <label className="form-label">Listen to</label>
              <select value={curAdor.listen.to} className="form-control">
                <option value=""></option>
                {
                  adorNameList && adorNameList.map((name) => <option value={name}>{name}</option>)
                }
              </select>
            </div>
          </div>

          <div className="row small mb-2">
            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text">New Source</span>
              <select value={curAdor.listen.trigger_source} className="form-control">
                <option value=""></option>
                <option value="userProfile">User Profile</option>
                <option value="customlist">Custom List</option>
                <option value="userAddressList">User Address List</option>
                <option value="departmentAddressList">Department Address List</option>
                <option value="imagelist">Image List</option>
              </select>
            </div>

            <div className="input-group input-group-sm mb-2" v-if="curAdor.listen.trigger_source == 'customlist' || curAdor.listen.trigger_source == 'imagelist'">
              <span className="input-group-text">Items E.g. ("value": 123, "preview": "/logo.jpg")</span>
              curAdor.listen.trigger_list_items
            </div>

            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text">New Fill With</span>
              <select value="curAdor.listen.trigger_fill_with" className="form-control" >
                <option value=""> </option>
                {
                  curAdor.trigger_source == 'userProfile' &&
                  <optgroup label="User Profile">
                    <option value="title">Title</option>
                    <option value="full_name">Full Name</option>
                    <option value="first_name">First Name</option>
                    <option value="last_name">Last Name</option>
                    <option value="email">Email</option>
                    <option value="phone">Phone</option>
                    <option value="cell">Cell</option>
                    <option value="fax">Fax</option>
                    {
                      custVars.map((ite, idx) => <option value={idx}>{item}</option>)
                    }
                  </optgroup>
                }
                {
                  (curAdor.listen.trigger_source == 'userAddressList' || curAdor.listen.trigger_source == 'departmentAddressList') &&
                  <optgroup label="Addresses">
                    <option value="title">Title</option>
                    <option value="line1">Line 1</option>
                    <option value="line2">Line 2</option>
                    <option value="city">City</option>
                    <option value="state">State Abbriviate</option>
                    <option value="province">State/Province</option>
                    <option value="zip_code">Zip Code</option>
                    <option value="country">Country</option>
                    <option value="phone">Phone</option>
                    <option value="citystate">City State</option>
                    <option value="citystatezip">City, State Zipcode</option>
                  </optgroup>
                }
              </select>
            </div>

            <div className="row small mb-2">
              <div className="col">
                <label className="form-label">New Format Text (substitude []) </label>
                <textarea value={curAdor.listen.trigger_format_text} className="form-control" >{curAdor.listen.trigger_format_text}</textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const canvasControls = () => {
    const canvasCtl = curAdor.canvas_control;
    return (
      <div className="card mb-2">
        <div className="card-header"><b>Interactive</b></div>
        <div className="card-body">
          <div className="form-group">
            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text" >Shape</span>
              <select value="canvasCtl && canvasCtl.shape" className="form-control">
                <option value="rect">Rectangle</option>
                <option value="circle">Circle</option>
                <option value="poly">Poly</option>
                <option value="control">Form Control</option>
              </select>
            </div>
            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text" >Left</span>
              <input value="canvasCtl && canvasCtl.left" type="number" step="10" className="form-control" />
            </div>
            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text" >Top</span>
              <input value="canvasCtl && canvasCtl.top" type="number" step="10" className="form-control" />
            </div>
            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text" >Right</span>
              <input value="canvasCtl && canvasCtl.right" type="number" step="10" className="form-control" />
            </div>
            <div className="input-group input-group-sm mb-2">
              <span className="input-group-text" >Bottom</span>
              <input value="canvasCtl && canvasCtl.bottom" type="number" step="10" className="form-control" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const fonts = () => {
    return (
      (curAdor.canvas_control && curAdor.font) &&
      <div className="card mb-2">
        <div className="card-body">
          <div className="input-group input-group-small mb-2">
            <span className="input-group-text">Font Family</span>
            <select value="curAdor.font.family" className="form-control" >
              <option value=""></option>
              <optgroup label="Web Fonts">
                {
                  fontFamilyList.webFonts &&
                  fontFamilyList.webFonts.map((item) =>
                    <option value={item}>{item}</option>
                  )
                }
              </optgroup>
              <optgroup label="Google Fonts">
                {
                  fontFamilyList.googleFonts &&
                  fontFamilyList.googleFonts.map((item) =>
                    <option value={item}>{item}</option>
                  )
                }
              </optgroup>
              <optgroup label="Custom Fonts">
                {
                  fontFamilyList.customFonts &&
                  fontFamilyList.customFonts.map((item) =>
                    <option value={item}>{item}</option>
                  )
                }
              </optgroup>
            </select>
          </div>

          <div className="input-group input-group-small mb-2">
            <span className="input-group-text">Font Size</span>
            <input type="text" list="fontSizeList" value={curAdor.font.size} className="form-control" />
            <datalist id="fontSizeList">
              <option value="10" />
              <option value="12" />
              <option value="14" />
              <option value="16" />
              <option value="18" />
              <option value="20" />
            </datalist>
            <span className="input-group-text">px</span>
          </div>

          <div className="input-group input-group-small mb-2">
            <span className="input-group-text">Font Weight</span>
            <select value="curAdor.font.weight" className="form-control">
              <option value=""> </option>
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
            </select>
          </div>
          <div className="input-group input-group-small mb-2">
            <span className="input-group-text">Color</span>
            <input value="curAdor.font.color" className="form-control" type="color" style="height:auto" />
          </div>
        </div>
      </div>
    )
  }

  // Save adors to server
  const saveAdors = () => {
    XmpieService.update(product.customer_id, product.id, adors)
      .then((res) => {
        if (res.data.result == 1) {
        }
        else {
          alert("Error occurs while saving adors");
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });

  }

  return (
    <>
      <div className="p-3">
        <h5>Current Ador Field</h5>
        <div className="form-group">
          <div className="input-group input-group-sm mb-2">
            <span className="input-group-text">Ador Name</span>
            <select className="form-control" name="curAdorName" value={curAdorName} onChange={handleChange}>
              <option value=""></option>
              {adorNameList && adorNameList.map((name) => <option value={name}>{name}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingGeneral">
            <button className="accordion-button" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseGeneral" aria-expanded="true" aria-controls="collapseGeneral">
              General
            </button>
          </h2>

          <div id="collapseGeneral" className="accordion-collapse collapse p-3"
            data-bs-parent="#accordionExample">
            <div className="">
              <div className="form-group">
                <div className="input-group input-group-sm mb-2">
                  <span className="input-group-text">Label</span>
                  {label()}
                </div>

                <div className="input-group input-group-sm mb-2">
                  <span className="input-group-text">Interface Type</span>
                  {uiType()}
                </div>

                <div className="input-group input-group-sm mb-2">
                  <span className="input-group-text">Fill Source</span>
                  {fillSource()}
                </div>

                <div className="input-group input-group-sm mb-2">
                  <span className="input-group-text">Fill With</span>
                  {fillWith()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOptions">
            <button className="accordion-button" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseOptions" aria-expanded="true" aria-controls="collapseOptions">
              Options
            </button>
          </h2>

          <div id="collapseOptions" className="accordion-collapse collapse p-3"
            data-bs-parent="#accordionExample">

            <div className="form-check-color">
              <input value={curAdor.required} name="required" className="form-check-input" type="checkbox" onChange={handleChange} />
              <label className="form-label ms-2">Required</label>
            </div>
            <div className="form-check-color">
              <input value={curAdor.hidden} name="hidden" className="form-check-input" type="checkbox" onChange={handleChange} />
              <label className="form-label ms-2">Hidden</label>
            </div>
            <div className="form-check-color">
              <input value={curAdor.read_only} name="read_only" className="form-check-input" type="checkbox" onChange={handleChange} />
              <label className="form-label ms-2">Ready Only</label>
            </div>

            <div className="input-group input-group-small mb-2">
              <span className="input-group-text">Validation</span>
              {selValidations()}
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFormat">
            <button className="accordion-button" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseFormat" aria-expanded="true" aria-controls="collapseFormat">
              Format
            </button>
          </h2>

          <div id="collapseFormat" className="accordion-collapse collapse p-3"
            data-bs-parent="#accordionExample">
            <div className="row small mb-2">
              <label className="form-label">Format Text</label>
              <textarea value={curAdor.format_text} className="form-control" placeholder="use {} for field substitution" ></textarea>
            </div>

            <div className="row small mb-2">
              <label className="form-label">Default Text (Use when empty)</label>
              <textarea value={curAdor.default_text} className="form-control" ></textarea>
            </div>

            <div className="row small mb-2">
              <label className="form-label">Qlango</label>
              <textarea value={curAdor.qlango} className="form-control" ></textarea>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTrigger">
            <button className="accordion-button" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseTrigger" aria-expanded="true" aria-controls="collapseTrigger">
              Trigger
            </button>
          </h2>

          <div id="collapseTrigger" className="accordion-collapse collapse p-3"
            data-bs-parent="#accordionExample">
            {triggers()}
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header" id="headingCanvas">
            <button className="accordion-button" type="button" data-bs-toggle="collapse"
              data-bs-target="#collapseCanvas" aria-expanded="true" aria-controls="collapseCanvas">
              Canvas
            </button>
          </h2>

          <div id="collapseCanvas" className="accordion-collapse collapse p-3"
            data-bs-parent="#accordionExample">
            {canvasControls()}

            {fonts()}
          </div>
        </div>
      </div>
      <div className="text-end mt-1 p-3">
        <button type="button" className="btn btn-primary" onClick={saveAdors}>Save</button>
      </div>
    </>
  )

}
export default CustomizeSetup;